import { useDispatch } from 'react-redux';
import { useNavigate as useOriginalNavigate } from 'react-router';
import { popFromHistory, pushToHistory } from '../state/history';
var useLinkNavigate = function () {
    var originalNavigate = useOriginalNavigate();
    var dispatch = useDispatch();
    var navigate = function (to, options) {
        if (typeof to === 'number') {
            if (to === -1) {
                dispatch(popFromHistory());
                originalNavigate(to);
            }
            else
                throw Error("invalid \"to\" arg: ".concat(to));
        }
        else {
            dispatch(pushToHistory(to));
            originalNavigate(to, options);
        }
    };
    return navigate;
};
export default useLinkNavigate;
